export const SET_ALL_FOIV_CATEGORIES_FETCHING = 'SET_ALL_FOIV_CATEGORIES_FETCHING';
export const SET_ALL_FOIV_CATEGORIES_ERROR = 'SET_ALL_FOIV_CATEGORIES_ERROR';
export const SET_ALL_FOIV_CATEGORIES = 'SET_ALL_FOIV_CATEGORIES';
export const CLEAN_ALL_FOIV_CATEGORIES = 'CLEAN_ALL_FOIV_CATEGORIES';
export const ABORT_ALL_FOIV_CATEGORIES_REQUEST = 'ABORT_ALL_FOIV_CATEGORIES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/AllFOIVCategories/actions.js